export const taggerKey = {
    GENERIC: 0,
    IHC: 1,
    BRAIN_AI: 2,
}